import { useGetComments } from "hooks/useGetComments";
import withRouter from "hoc/withRouter";
import {
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  Table,
  TableBody,
  CircularProgress,
  Tooltip,
  IconButton,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
} from "@mui/material";
import { toDate } from "helpers/dateHelper";
import { FaEdit, FaEye, FaInfoCircle, FaQuestionCircle, FaReply, FaTrash } from "react-icons/fa";
import { useRef, useState } from "react";
import commentsService from "services/admin/commentsService";
import { toast } from "react-toastify";

const Comments = ({
  router: {
    params: { id: agentID },
  },
}: any) => {
  const { data: comments, isLoading, error, refetch } = useGetComments({ agentID: agentID });
  const [isReplyOpen, setIsReplyOpen] = useState(false);
  const commentTextRef = useRef<any>(null);
  const [selectedComment, setSelectedComment] = useState<any>(null);

  const [isEditOpen, setIsEditOpen] = useState(false);

  const handleReply = async () => {
    console.log(commentTextRef.current.value);
    setIsReplyOpen(false);

    try {
      const response = await commentsService.replyToComment(selectedComment.id, {
        text: commentTextRef.current.value,
      });
      console.log(response);
      toast.success("Комментарий отправлен");
    } catch (error) {
      console.error(error);
      toast.error("Ошибка при отправке комментария");
    }
  };

  const handleEdit = async (commentID: number) => {
    console.log(commentID);
    try {
      const response = await commentsService.editComment(commentID);
      console.log(response);
      toast.success("Комментарий отредактирован");
      refetch();
    } catch (error) {
      console.error(error);
      toast.error("Ошибка при редактировании комментария");
    }
  };

  const handleDelete = async (commentID: number) => {
    if (window.confirm("Вы уверены, что хотите удалить комментарий?")) {
      console.log(commentID);
      try {
        const response = await commentsService.deleteComment(commentID);
        console.log(response);
        toast.success("Комментарий удален");
      } catch (error) {
        console.error(error);
        toast.error("Ошибка при удалении комментария");
      }
      refetch();
    }
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-full">
        <CircularProgress />
      </div>
    );
  }
  if (error) {
    return (
      <div className="flex justify-center items-center h-full">
        <div>Error: {error.message}</div>
      </div>
    );
  }

  return (
    <div>
      <h3 className="mb-4">
        Комментарии
        <Tooltip
          title="Здесь вы можете просматривать и управлять комментариями, оставленными пользователями в
          социальных сетях."
        >
          <IconButton>
            <FaQuestionCircle size={14} />
          </IconButton>
        </Tooltip>
      </h3>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Аккаунт</TableCell>
              <TableCell>Пользователь</TableCell>
              <TableCell>ID медиа</TableCell>
              <TableCell>Тип медиа</TableCell>
              <TableCell>Комментарий</TableCell>
              <TableCell>Платформа</TableCell>
              <TableCell>Дата создания</TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {comments?.rows?.map((comment: any) => (
              <TableRow key={comment.id} style={{                                
                opacity: comment.hidden ? 0.5 : 1                
              }}>
                <TableCell>{comment.id}</TableCell>
                <TableCell>{comment.externalAccountUserName}</TableCell>
                <TableCell>{comment.externalUserUserName}</TableCell>
                <TableCell>{comment.externalMediaID}</TableCell>
                <TableCell>{comment.externalMediaType}</TableCell>
                <TableCell>{comment.text}</TableCell>
                <TableCell>{comment.source}</TableCell>
                <TableCell>{toDate(comment.createdAt)}</TableCell>
                <TableCell>
                  <Tooltip title="Ответить">
                    <IconButton
                      onClick={() => {
                        setIsReplyOpen(true);
                        setSelectedComment(comment);
                      }}
                    >
                      <FaReply size={14} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
                <TableCell>
                  <Tooltip title="Скрыть/Показать">
                    <IconButton onClick={() => handleEdit(comment.id)}>
                      <FaEye size={14} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
                <TableCell>
                  <Tooltip title="Удалить">
                    <IconButton onClick={() => handleDelete(comment.id)}>
                      <FaTrash size={14} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={isReplyOpen} onClose={() => setIsReplyOpen(false)}>
        <DialogTitle>Ответить на комментарий</DialogTitle>
        <DialogContent>
          <TextField label="Комментарий" fullWidth multiline rows={4} inputRef={commentTextRef} />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleReply}>
            Ответить
          </Button>
        </DialogActions>
      </Dialog>
      {/* <Dialog open={isEditOpen} onClose={() => setIsEditOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Редактировать комментарий</DialogTitle>
        <DialogContent>
          <div className="mt-4">
            <TextField
              label="Комментарий"
              fullWidth
              multiline
              rows={4}
              defaultValue={selectedComment?.text || ""}
              inputRef={commentTextRef}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleEdit}>
            Обновить комментарий
          </Button>
        </DialogActions>
      </Dialog> */}
    </div>
  );
};

export default withRouter(Comments);
